import * as errorPageTypes from '../../consts/app/errorPageTypes';
import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';
import HttpErrorHandlerService from '../httpErrorHandlerService';
import appRouterService from '../route/appRouterService';

const iccResponseErrorCheckService = (error, isHandleError = true) => {
    const isAuthError = error?.response?.status === httpErrorsTypes.NOT_AUTHORIZED;

    if (isAuthError) {
        appRouterService.forwardToErrorHandlingPage(errorPageTypes.ICC_TEMPORARY_ERROR);
    } else {
        if (isHandleError) {
            new HttpErrorHandlerService().handleError(error);
        }
        throw error;
    }
};

export default iccResponseErrorCheckService;
